import React from "react";
import {Box, Button, Grid, Modal, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ClosePopupBtn} from "../closePopupBtn/closePopupBtn";

const useStyles = makeStyles(() => ({
    confirmPopupHeader: {
        padding: `6px 20px`,
        background: `linear-gradient(89.41deg, #0198D2 0%, #3540A8 100%)`,
        '& .MuiButton-root': {
            '& > svg': {
                '& > path': {
                    fill: `#ffffff`
                }
            }
        }
    },
    mainBtn: {
        // width: `100%`,
        background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
        '&.MuiButton-root': {
            padding: `10px 20px`,
            textTransform: `inherit`
        },
        '&.Mui-disabled': {
            opacity: `0.5`,
        },
        '& > .MuiTypography-root': {
            lineHeight: `15px`
        }
    },
    secondaryBtn: {
        // width: `100%`,
        background: `#ffffff`,
        '&.MuiButton-root': {
            padding: `10px 20px`,
            border: `1px solid #DD5A01`,
            textTransform: `inherit`
        },
        '&.Mui-disabled': {
            opacity: `0.5`,
        },
        '& > .MuiTypography-root': {
            lineHeight: `15px`,
            color: `#DD5A01`,
            fontWeight: `700`
        }
    },


}))

interface Props {
    onClose: (value: boolean) => void;
    contentText: string;
    onConfirm: VoidFunction;
    buttonText: string[];
    onCloseWithoutSaving?: VoidFunction;
    isSaveDisabled?: boolean;
}

export const SimpleConfirmPopup: React.FC<Props> = ({
                                                        onClose,
                                                        contentText,
                                                        onConfirm,
                                                        buttonText,
                                                        onCloseWithoutSaving,
                                                        isSaveDisabled = false
                                                    }) => {
    const classes = useStyles()
    const onClosePopup = () => {
        onClose(false);
    }

    const buttons = buttonText.map((value: string, index: number) => {
        let isDisabled = false;
        if(value === "Save"){
            isDisabled = isSaveDisabled;
        }
        return <Button key={index} onClick={() => {
            switch (index) {
                case 0: {
                    onConfirm();
                    break;
                }
                case 1: {
                    if (typeof onCloseWithoutSaving === 'function') {
                        onCloseWithoutSaving()
                    }
                    break;
                }
                case 2: {
                    onClosePopup()
                    break;
                }
            }
            onClosePopup();
        }} className={index === 0 ? classes.mainBtn : classes.secondaryBtn} disabled={isDisabled}>
            <Typography color={`white`}>
                {value}
            </Typography>
        </Button>

    })

    return (
        <Modal
            sx={{
                display: `flex`,
                justifyContent: `center`,
                mt: `10vh`,
                alignItems: `start`,
                zIndex: 1502
            }}
            open={true}
        >
            <Box sx={{
                width: `350px`,
                height: `auto`,
                backgroundColor: `white`,
            }}>
                {/*header*/}
                <Box className={classes.confirmPopupHeader}>
                    <Grid container alignItems={`center`}>
                        <Grid item xs={10}>
                        </Grid>
                        <Grid item xs>
                            <Box sx={{display: `flex`, justifyContent: `flex-end`}}>
                                <ClosePopupBtn onClose={onClosePopup}/>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/*text content*/}
                <Box p={`20px`} display={`flex`}>
                    <Typography sx={{whiteSpace: 'pre-wrap'}}>
                        {contentText}
                    </Typography>
                </Box>
                {/*button wrapper*/}
                <Box px={`20px`} pb={`10px`} justifyContent={buttonText.length === 1 ? `space-around` : `space-between`}
                     display={`flex`}>
                    {buttons}
                    {/*<Grid container alignItems={`center`} justifyContent={`flex-end`}>*/}
                    {/*    <Grid item xs={4}>*/}
                    {/*    </Grid>*/}
                    {/*</Grid>*/}
                </Box>

            </Box>
        </Modal>
    )
}